import fetch from "lib/fetch";

export const getAutocompleteUserRequest = (params?: HashMap<unknown>) =>
    fetch.get(`autocomplete/user`, { params });

export const getAutocompleteCompanyRequest = (params?: HashMap<unknown>) =>
    fetch.get(`autocomplete/company`, { params });

export const getAutocompleteCategorySubCategoryRequest = (params?: HashMap<unknown>) =>
    fetch.get(`autocomplete/category_subcategory`, { params });

export const getAutocompleteAddressRequest = (params?: HashMap<unknown>, type: string = "housenumber") =>
    fetch.get(
        `https://data.geopf.fr/geocodage/search?type=${type}`,
        {
            params,
            withCredentials: false,
        },
        true
    );

export const getAutocompleteCommuneAddressRequest = (params?: HashMap<unknown>) => {
    const maybeNom = params && typeof params.nom === "string" ? params.nom : undefined;
    let effectiveParams = params;
    if (maybeNom && maybeNom.includes("@")) {
        const parts = maybeNom.split("@");
        effectiveParams = {
            nom: parts[0],
            code: parts[1],
        };
    }

    return fetch.get(
        `https://geo.api.gouv.fr/communes`,
        {
            params: effectiveParams,
            withCredentials: false,
        },
        true
    );
};
